import Edit from "./edit"
import View from "./view"

export default { view: View, edit: Edit }
